import { configureStore } from "@reduxjs/toolkit";
import areaSlice from "./slice/areaSlice";
import digitalSlice from "./slice/digitalSlice";
import bookSlice from "./slice/bookSlice";
import chooseSlice from "./slice/chooseSlice";

const store = configureStore({
  reducer: { areaSlice, digitalSlice, bookSlice, chooseSlice },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
